export function onReady(callback) {
  if (document.readyState === "interactive" || document.readyState === "complete") {
    if (browserSupportsAllFeatures()) {
      callback();
    } else {
      loadScript("/build/polyfill.js", callback);
    }
  }
}

function browserSupportsAllFeatures() {
  return window.Promise && window.fetch && window.Symbol;
}

function loadScript(src, done) {
  var js = document.createElement("script");
  js.src = src;
  js.onload = function () {
    done();
  };
  js.onerror = function () {
    done(new Error("Failed to load script " + src));
  };
  document.head.appendChild(js);
}
